import Vue from 'vue'
import Vuex from 'vuex'
import user from '@/core/user'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    isLoggedIn: !!localStorage.getItem('evedUser') && localStorage.getItem('evedUser') !== '{}',
    isSessionValid: false,
    csrf: !!localStorage.getItem('evedUserCsrf') && localStorage.getItem('evedUserCsrf')
  },

  actions: {
    ping ({commit}) {
      setTimeout(() => user.checkSession(commit))
    },
    check () {
      setTimeout(() => user.checkSession(true))
    }
  },

  mutations: {
    updateSessionValidity (state, payload) {
      state.isSessionValid = payload
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/store/index.js